module.exports = __webpack_public_path__ + "h5/img/cs_01.d455aeec.jpg";